import { useQuery } from "@tanstack/react-query";

import { listMeasurements, type StageMeasurement } from "@/adapters/api";
import type { HistoryTarget } from "../types.ts";
import { toMeasurement } from "../utils/map.ts";
import { measurementKeys } from "../utils/query-keys.ts";

const PAGE_SIZE = 100;

export function useMeasurementHistory(
	constructionId: string | undefined,
	target: HistoryTarget | null,
) {
	return useQuery({
		queryKey: measurementKeys.history(constructionId, target?.id),
		queryFn: async () => {
			const items: StageMeasurement[] = [];
			for (let page = 1; ; page++) {
				// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
				const response = await listMeasurements(constructionId!, {
					stageId: target?.id,
					includeDescendants: !target?.isLeaf,
					page,
					pageSize: PAGE_SIZE,
				});
				items.push(...response.items);
				if (
					response.items.length < PAGE_SIZE ||
					items.length >= response.count
				) {
					break;
				}
			}
			return items.map(toMeasurement);
		},
		enabled: !!constructionId && !!target,
		staleTime: 0,
	});
}
